import { OnlineShop } from './types'
import { cmsCLient } from '@/services/axiosConfig'

export type GetOnlineShopRes = OnlineShop[]

export type GetOnlineShops = () => Promise<GetOnlineShopRes>

export const getOnlineShops: GetOnlineShops = async () => {
  try {
    const response = await cmsCLient.get('/Onlineshop-banners')
    return response.data.data
  } catch (e: any) {
    console.error('Failed to fetch online shops:', e.message)
    return []
  }
}
